
<template>
	<SearchFilterComponent
		store-key="projects"
		input-placeholder="Search for a project"
		:show-search-input="active_tab !== 'example_projects'"
	/>

	<Transition
		v-if="user_is_staff"
		name="fade"
	>
		<div
			v-show="active_tab !== 'example_projects' && show_filters"
			class="filters mt-16 mb-40"
		>
			<div
				v-if="loading"
				class="flex flex--justify-center"
			>
				<PageLoaderComponent :small="true" />
			</div>
			<div
				v-else
				class="filters__row"
			>
				<div class="filters__column filters__column--space-between">
					<div class="full-width">
						<div
							v-if="selected_dropdown_filter_components.length"
							class="grid grid--stretch grid--xs flex flex--wrap full-width mb-8"
						>
							<div
								v-for="filter in selected_dropdown_filter_components"
								:key="'dropdown-filter-component-' + filter.value"
								class="grid__item a4-12 c6-12 mb-8"
							>
								<DropdownFilterComponent
									store-key="projects"
									:label="filter.label"
									:filter-key="filter.value"
									:filter-options-key="filter.options_key ?? null"
									:get-options-method="filter.get_options_method ?? null"
									:search-disabled="filter.search_disabled ?? false"
								/>
							</div>
						</div>
						<p
							v-else
							class="mb-16"
						>
							No filters selected
						</p>
						<button
							class="edit-filters"
							@click="show_filter_modal = true"
						>
							Choose filters
						</button>
					</div>
					<Teleport to="#modal">
						<Transition name="fade">
							<FilterModalComponent
								v-if="show_filter_modal"
								store-key="projects"
								@close-modal="show_filter_modal = false"
							/>
						</Transition>
					</Teleport>

					<ProjectActiveDropdownFiltersComponent />
				</div>
				<div class="filters__column">
					<TagsFilterComponent
						store-key="projects"
					/>
				</div>
			</div>
		</div>
	</Transition>
</template>

<script setup>
import DropdownFilterComponent from './filters/DropdownFilterComponent';
import ProjectActiveDropdownFiltersComponent from './filters/ProjectActiveDropdownFiltersComponent';
import FilterModalComponent from './modals/FilterModalComponent';
import TagsFilterComponent from './filters/TagsFilterComponent';
import SearchFilterComponent from './filters/SearchFilterComponent';
import PageLoaderComponent from './PageLoaderComponent';

import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useDataStore } from '../stores/data';
import { useProjectFiltersStore } from '../stores/project-filters';
import { USER_GROUP_STAFF } from '../constants';

const data_store = useDataStore();
const filters_store = useProjectFiltersStore();

const { user_group } = storeToRefs( data_store );

const {
	getBoundaryStaffUsers,
	getCompanies,
	getMediaTypes,
	getProjectTypes,
	getProjectLocations,
	getDefaultFilters,
	getCommonOptions,
	getProjectStatusOptions
} = filters_store;

const {
	active_tab,
	show_filters,
	dropdown_filter_components
} = storeToRefs( filters_store );

const show_filter_modal = ref( false );

const user_is_staff = computed( () => {
	return user_group.value === USER_GROUP_STAFF;
} );

const selected_dropdown_filter_components = computed( () => {
	return dropdown_filter_components.value.filter( filter => filter.selected );
} );

const loading = ref( true );

onMounted ( async() => {
	await getDefaultFilters();
	await getBoundaryStaffUsers();
	await getCompanies();
	await getMediaTypes();
	await getProjectTypes();
	await getProjectLocations();
	await getCommonOptions();
	await getProjectStatusOptions()
	loading.value = false;
} );
</script>